export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
            <defs>
                <filter x="-3.2%" y="-25.0%" width="106.4%" height="150.0%" filterUnits="objectBoundingBox" id="filter-1">
                    <feOffset dx="0" dy="-2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix
                        values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0650677448 0"
                        type="matrix"
                        in="shadowBlurOuter1"
                        result="shadowMatrixOuter1"
                    ></feColorMatrix>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
            </defs>
            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="2筛选框+-1-搜索框" transform="translate(-255.000000, -2257.000000)">
                    <g id="编组-11" filter="url(#filter-1)" transform="translate(0.000000, 2242.000000)">
                        <g id="编组-10" transform="translate(102.000000, 15.000000)">
                            <g id="-mockplus-" transform="translate(153.000000, 0.000000)">
                                <g id="按钮/下拉" transform="translate(9.000000, 9.000000) rotate(-360.000000) translate(-9.000000, -9.000000) ">
                                    <rect id="矩形" x="0" y="0" width="18" height="18"></rect>
                                    <path
                                        d="M8.41543637,8.775 L11.9549072,12.3468747 C12.0849674,12.4781256 12.15,12.6374991 12.15,12.825 C12.15,13.012501 12.0849674,13.1718743 11.9549072,13.303125 C11.824847,13.4343757 11.6669207,13.5 11.4811208,13.5 C11.2953209,13.5 11.1373932,13.4343757 11.0073335,13.303125 L6.96620371,9.225 C6.6689237,8.92499863 6.67821357,8.61562646 6.99407356,8.29687371 L11.0073335,4.24687371 C11.1373932,4.11562286 11.2953209,4.05 11.4811208,4.05 C11.6669207,4.05 11.824847,4.11562286 11.9549072,4.24687371 C12.0849674,4.37812457 12.15,4.53749657 12.15,4.725 C12.15,4.91250343 12.0849674,5.07187543 11.9549072,5.20312629 L8.41543637,8.775 Z"
                                        id="Fill-1"
                                        fill="currentColor"
                                        transform="translate(9.450000, 8.775000) scale(-1, 1) translate(-9.450000, -8.775000) "
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
